import ReactDOM from 'react-dom';
import React from 'react';
import { Components, Parts } from 'zero';

const dom = {};

const {
  Button,
  Input,
  DatePicker,
  Textarea,
  Select,
  Radio,
  Checkbox,
  Container,
  Toaster,
  Modal,
  RichEditor,
  Dynamic,
  Loader
} = Components;

const { SearchPart, TablePart } = Parts;

const marginStyle = {
  margin: '10px'
};

const checkboxOptions = [{ value: 1, text: 'haha', checked: true }, { value: 2, text: 'haha2' }, { value: 3, text: 'haha3', disabled: true }];

const click = function (event) {
  console.log('onclick');
  console.log(event);
  console.log(dom);
  // marginStyle.margin = '40px';
};

const onchange = function (date) {
  console.log(date);
};

const searches = [{
  type: 'text',
  key: 'tel',
  errorMsg: '手机号错误',
  name: '贷款产品编号'
}, {
  type: 'text',
  key: 'name',
  valid: 'number',
  errorMsg: '手机号错误',
  name: '贷款产品名称'
}, {
  type: 'select',
  key: 'type',
  valid: 'number',
  errorMsg: '手机号错误',
  name: '贷款产品类型',
  value: -1,
  options: [{
    value: '', text: '请选择'
  }, {
    value: 1, text: 2
  }, {
    value: 2, text: 3
  }]
}, {
  type: 'select',
  key: 'channel',
  valid: 'number',
  errorMsg: '手机号错误',
  name: '贷款银行渠道',
  options: [{
    value: 1, text: 12
  }, {
    value: 2, text: 13
  }]
}, {
  type: 'timePickerRange',
  key: 'time',
  valid: 'number',
  errorMsg: '手机号错误',
  name: '贷款创建时间',
}];

const listData = [{
  no: '001',
  name: '很大',
  money: 12.111,
  date: 1494175550738,
  status: 0
}, {
  no: '002',
  money: 13,
  name: '很大',
  date: 1494275850738,
  status: 1
}, {
  no: '003',
  money: 13.1,
  name: '很大',
  date: 1494574850738,
  status: 1
}];

const listFormat = [{
  key: 'no',
  title: '贷款产品编号'
}, {
  key: 'name',
  title: '贷款产品名称'
}, {
  key: 'type',
  title: '贷款产品类型',
  format: ['fixed', 2],
}, {
  key: 'channel',
  title: '银行渠道',
  format: ['fixed', 2],
}, {
  key: 'repaymentMethod',
  title: '还款方式',
  format: ['fixed', 2],
}, {
  key: 'money',
  title: '产品期限类型',
  format: ['fixed', 2],
}, {
  key: 'money',
  title: '产品总配额',
  format: ['fixed', 2],
}, {
  key: 'date',
  title: '贷款创建时间',
  format: ['date', 'yyyy-MM-dd hh:mm:ss']
}, {
  key: 'status',
  title: '贷款产品状态',
  format: {
    0: '成功',
    1: '失败'
  }
}];

const operations = [{
  type: 'add',
  url: 'aa.html',
  auth: 'aa',
}, {
  type: 'delete',
  func: (idx, item) => {
    console.log('delete', idx, item);
  },
  auth: 'bb',
}, {
  text: '自定义',
  func: (idx, item) => {
    console.log('自定义', idx, item);
  },
  auth: 'cc',
}, {
  text: 'edit',
  func: (idx, item) => {
    console.log('隐藏', idx, item);
  },
  auth: 'edit',
}];

ReactDOM.render(
  <div>
    <Container
      title="查询列表"
      style={{
        marginBottom: '20px'
      }}
    >
      <Button
        text="确定"
        type={['primary']}
        style={marginStyle}
      />
      <Button
        text="确定"
        onClick={click}
        style={marginStyle}
      />
      <Button
        text="确定"
        style={marginStyle}
        disabled
      />
      <Button
        text="确定"
        style={marginStyle}
        type={['primary', 'small']}
        disabled
      />
      <Button
        text="确定"
        style={marginStyle}
        type={['primary', 'large']}
      />
      <Button
        text="确定"
        style={marginStyle}
        type={['primary', 'small']}
      />
      <br />
      <Input
        placeholder="我是placeholder"
        style={marginStyle}
        maxLength={10}
        maxLengthShow={false}
        disabled
      />
      <Input
        ref={(input) => { dom.input = input; }}
        placeholder="我是placeholder"
        style={marginStyle}
        maxLength={10}
      />
      <Input
        value="我是value"
        style={marginStyle}
        maxLength={100}
      />
      <Input
        placeholder="请输入"
        style={marginStyle}
        typeStyle="half"
        maxLength={100}
      />
      <br />
      <Textarea
        value="我是文本"
        style={marginStyle}
        maxLengthShow={false}
        disabled
      />
      <Textarea
        placeholder="我是placeholder"
        style={marginStyle}
      />
      <Textarea
        value="我是value"
        style={marginStyle}
        maxLength={100}
      />
      <Textarea
        value="我是value"
        style={marginStyle}
        maxLength={100}
        typeStyle="half"
      />
      <br />
      <Select
        style={marginStyle}
        options={[{ value: 1, text: 'haha' }, { value: 2, text: 'haha2' }]}
        disabled
      />
      <Select
        style={marginStyle}
        options={[{ value: 1, text: 'haha' }, { value: 2, text: 'haha2' }]}
      />
      <br />
      <Radio
        options={[{ value: 1, text: 'haha' }, { value: 2, text: 'haha2', checked: true }]}
        onChange={click}
      />
      <br />
      <Checkbox
        ref={(checkbox) => { dom.checkbox = checkbox; }}
        options={checkboxOptions}
        onChange={click}
      />
      <br />
      <Button
        text="success"
        type={['primary']}
        style={marginStyle}
        onClick={() => { Toaster.toaster({ type: 'success', content: 'this is a success', time: 2000 }); }}
      />
      <Button
        text="error"
        type={['primary']}
        style={marginStyle}
        onClick={() => { Toaster.toaster({ type: 'error', content: 'this is a error' }); }}
      />
      <Button
        text="normal"
        type={['primary']}
        style={marginStyle}
        onClick={() => { Toaster.toaster({ type: 'normal', content: 'this is a normal' }); }}
      />
      <Button
        text="warning"
        type={['primary']}
        style={marginStyle}
        onClick={() => { Toaster.toaster({ type: 'warning', content: 'this is a warning' }); }}
      />
      <Button
        text="confirm"
        type={['primary']}
        style={marginStyle}
        onClick={() => { Modal.confirm({ tirtle: 'warning', content: 'this is a warning' }, () => { alert('this is sure callback'); }, () => { alert('this is cancle callback'); }); }}
      />
      <Button
        text="alert"
        type={['primary']}
        style={marginStyle}
        onClick={() => { Modal.alert({ tirtle: 'warning', content: 'this is a warning' }, () => { console.log('alert'); }); }}
      />
      <Button
        text="mult open"
        type={['primary']}
        style={marginStyle}
        onClick={() => {
          Modal.alert({ tirtle: 'warning',
            content: (<div><a onClick={() => { Modal.confirm({ tirtle: 'warning', content: 'this is a warningthis is a warningthis is a warningthis is a warningthis is a warningthis is a warningthis is a warningthis is a warningthis is a warningthis is a warningthis is a warningthis is a warningthis is a warning' }, () => { console.log('this is callback'); }, () => { console.log('this is cancle callback'); }); }} >click to do a new Alert</a></div>) },
            () => { console.log('nult callback'); });
        }}
      />
      <Button
        text="Loader show"
        type={['primary']}
        style={marginStyle}
        onClick={() => {
          Loader.show({ type: 'normal', content: 'this is a normal' });
        }}
      />
      {
        // <SearchPart url="http://www.baidu.com/" />
      }
    </Container>


    <SearchPart
      title="查询列表"
      url="http://www.baidu.com/"
      conditions={searches}
    />
    <TablePart
      title="查询结果"
      items={listData}
      minWidth={1200}
      itemFormat={listFormat}
      operations={operations}
    />

    <Container
      title="其他"
      style={{
        margin: '40px 0px',
      }}
    >
      <br />
      <DatePicker
        onChange={onchange}
        format="YYYY-MM-DD"
        placeholder="请选择日期"
      />
      <DatePicker
        onChange={onchange}
        format="HH:mm:ss"
        viewMode="time"
        placeholder="请选择时间"
      />
      <DatePicker onChange={onchange} format="YYYY" viewMode="years" placeholder="请选择年份" />
      <DatePicker onChange={onchange} format="MM" viewMode="months" placeholder="请选择月份" />
    </Container>

    <RichEditor />
    <Dynamic
      WrappedComponent={Button}
      text="提交"
    />
  </div>
  ,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./example/src/page/sample/index.js